import PriceConverter from '../../../helpers/PriceConverter'
import { FormattedMessage } from 'react-intl'
import get from 'lodash/get'
import { dummyImagePath } from 'config'
import { pushToDataLayer } from 'gtm'
import { target } from 'utils'

export const LiveaboardSliderCard = ({ item }) => {
  const picture = get(
    item,
    'backgrounds.GridSearchResultDesktop',
    dummyImagePath
  )
  const handleClick = () => {
    if(item.impression) {
      pushToDataLayer({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: window.currentPageTypeAdventures },
            products: [item.impression],
          },
        },
      })
    }
  }

  return (
    <div key={item.id} className='operator-item-wrapper'>
      <a
        className='operator-item-card element operator-item-card-container'
        href={item.url}
        onClick={handleClick}
        data-navigation-elements='data-navigation-elements'
        data-region-identifier='book-diving'
        target={target}
      >
        <div className='img-wrapper ratio-16-9'>
          <span
            style={{ backgroundImage: `url(${picture})` }}
            className='img'
          />
        </div>

        <div className='operator-item-card__content'>
          <strong className='operator-item-card__title'>{item.title}</strong>
          <ul className='features'>
            <li>
              <i className='font-icons location-icon' />
              {item.areaTitle}, {item.countryTitle}
            </li>
            <li>
              <i className='font-icons dive-center-icon' />
              <FormattedMessage
                id='including_dives_fixed'
                defaultMessage='Including 14-20 dives'
              />
            </li>
          </ul>
          <div className='price-wrap'>
            <span className='price-type'>
              <FormattedMessage id='from' defaultMessage='From' />
            </span>
            <span className='price'>
              <PriceConverter
                amount={item.minimumPrice}
                currency={item.currency}
              />
            </span>
            <span className='price-type'>
              <FormattedMessage id='per_day' defaultMessage='per day' />
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}
